module.exports = __webpack_public_path__ + "static/media/au-coeur-de-l-actualite-des-consomacteurs-la-fast-fashion-mini.3d18040e.jpg";